import { useCreateState } from '../../../../hooks/useCreateState';
import { flowItemTypeEnum } from '../utils';

const initialState = {
  top: 0,
  left: 0,

  isVisible: false,
  isCustomComponentsList: false,

  selectedItemType: flowItemTypeEnum.PROCESS_MESSAGE_RESPONSE_TASK,

  initialFlowItem: null,
  // need for create Component_Name_N structure
  createdComponentNames: {},
};

export function useAppState() {
  return useCreateState({
    initialState,
    reducers: {
      show: (
        state,
        action: { payload: {
          top: number,
          left: number,
          initialFlowItem: any,
          selectedItemType: typeof flowItemTypeEnum[keyof typeof flowItemTypeEnum]
        }}
      ) => ({
        ...initialState,
        top: action.payload.top,
        left: action.payload.left,
        initialFlowItem: action.payload.initialFlowItem,
        isVisible: true,
        selectedItemType: action.payload.selectedItemType,
        createdComponentNames: state.createdComponentNames
      }),

      hide: (state) => ({ ...state, isVisible: false }),

      setItemType: (state, action: { payload: { itemType: typeof flowItemTypeEnum[keyof typeof flowItemTypeEnum] } }) => {
        const itemType = action.payload.itemType;
        return { ...state, selectedItemType: itemType};
      },

      addCreatedComponentName: (state, action) => {
        return {
          ...state,
          createdComponentNames: {
            ...state.createdComponentNames,
            [action.payload]: true
          }
        }
      }
    },
    selectors: {
    }
  });
}
